import { theme } from 'antd';
const { useToken } = theme;
export { useToken };
